import { render, staticRenderFns } from "./Nacin.vue?vue&type=template&id=34c6635b&scoped=true&"
import script from "./Nacin.vue?vue&type=script&lang=js&"
export * from "./Nacin.vue?vue&type=script&lang=js&"
import style0 from "./Nacin.vue?vue&type=style&index=0&id=34c6635b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6635b",
  null
  
)

export default component.exports